// shared.module.ts

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GlobalLeadersComponent } from '../Components/global-leaders/global-leaders.component';
import { TestimonialComponent } from '../Components/testimonial/testimonial.component';
import { GrammarTipsModalComponent } from '../Components/videos/grammar-tips/grammar-tips-modal/grammar-tips-modal.component';
import { ProductWalkthroughtModalComponent } from '../Components/product-walkthrought-modal/product-walkthrought-modal.component';
import { GetTrinkaComponent } from '../Components/enterprise/get-trinka/get-trinka.component';
import { RouterModule } from '@angular/router';
import { TrustedGlobalLeadersComponent } from '../Components/enterprise/trusted-global-leaders/trusted-global-leaders.component';
import { WhitepaperSectionComponent } from '../Components/features/features-shared/whitepaper-section/whitepaper-section.component';
import { CaptureLeadsModule } from './capture-lead/capture-lead.module';
import { DownloadInfoSheetComponent } from '../Components/enterprise/data-sensitive-plan/download-info-sheet/download-info-sheet.component';
import { PowerModeSectionComponent } from '../Components/features/power-mode-section/power-mode-section.component';
import { OSUSectionComponent } from '../Components/features/features-shared/osusection/osusection.component';

@NgModule({
  declarations: [
    GlobalLeadersComponent,
    TestimonialComponent,
    GrammarTipsModalComponent,
    ProductWalkthroughtModalComponent,
    GetTrinkaComponent,
    TrustedGlobalLeadersComponent,
    WhitepaperSectionComponent,
    DownloadInfoSheetComponent,
    PowerModeSectionComponent,
    OSUSectionComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    CaptureLeadsModule
  ],
  exports: [
    GlobalLeadersComponent,
    TestimonialComponent,
    GrammarTipsModalComponent,
    ProductWalkthroughtModalComponent,
    GetTrinkaComponent,
    TrustedGlobalLeadersComponent,
    WhitepaperSectionComponent,
    DownloadInfoSheetComponent,
    PowerModeSectionComponent,
    OSUSectionComponent
  ]
})

export class SharedModule { }
